import React, { Component } from 'react'
import { isAuthenticated } from '../utils/authHelper';

class ViewPNGFiles extends Component{

    isLoggedIn() {
        return isAuthenticated();
    }
    render(){
        const rawSearch = (window.location.search || '').replace(/^\?/, '');
        let url = rawSearch;
        if (rawSearch.indexOf('url=') === 0) {
            const params = new URLSearchParams(rawSearch);
            url = params.get('url') || '';
        } else if (!rawSearch) {
            url="https://zaps.zolostays.com/error";
        }
        try {
            url = decodeURIComponent(url);
        } catch (e) {
            url="https://zaps.zolostays.com/error";
        }
        return(
            <img src={url} width='100%' height='auto' alt="Failed to load image" />
        )
    }
}
export default ViewPNGFiles;


// WEBPACK FOOTER //
// ./src/components/ViewPNGFiles.js